import { SustainabilityService, submissionService } from "../../services"
import { apolloError } from "../bugsnag/notify"

import { loadingAlert, success } from "../alert"
import { activityService, indicatorService } from "../../services"


export const BlockComponent = async(
    isblocking, //para los casos donde se envia todo el objeto o solo el estado
    id,
    type,
    onSucces
) =>{
    const saving = loadingAlert()
    if(type === "sustainability" || type ==="riskManagementsAll" || type === "riskManagements" ){
        
        const types = {
            sustainability:"sustainabilityIsBlocking",
            riskManagementsAll : "riskManagementIsBlocking",
            riskManagements:"riskManagements"
        }
        
        const data = {[types[type]]:isblocking, id:id}

    try {
      
       await SustainabilityService().editSustainabilityDetails(data) 
      success()
    } catch (error) { 
      console.error(error)
      apolloError(error)
    } finally {
      saving()
      onSucces()
    }
    }

    if(type === "indicador"){
      
      try {
        await indicatorService().updateIndicators({indicators:[isblocking]}) 
       success()
     } catch (error) { 
       console.error(error)
       apolloError(error)
     } finally {
       saving()
       onSucces()
     }
    }

    if(type=== "Actividad"){
      try {
      
        await activityService().updateActivities({activities:[isblocking]})
       success()
     } catch (error) { 
       console.error(error)
       apolloError(error)
     } finally {
       saving()
       onSucces()
     }
    }

    //consultas a graph mediante tipo


    return false
}